import { languageConstants } from "../constants/language.constants";
import { appService } from "../services/index";

export const languageActions = {
  downloadLabels
};

function downloadLabels(languageCode) {
  return dispatch => {
    dispatch(request());
    appService
      .downloadLabels(languageCode)
      .then(labels => {
        dispatch(success(labels));
      })
      .catch(error => {
        dispatch(failure(error));
      });
  };

  function request(lan) {
    return { type: languageConstants.LABELS_REQUEST, lan };
  }
  function success(labels) {
    return { type: languageConstants.LABELS_SUCCESS, labels };
  }
  function failure(error) {
    return { type: languageConstants.LABELS_FAILURE, error };
  }
}